import React from "react";
import { Card } from "react-bootstrap";
import "./NoviZahtjeviZaUslugamaCard";

function HistorijaSaradnje({ naziv, kontakt, cijena, datum }) {
  return (
    <>
      <Card className="card-saradnja-ponude">
        <Card.Body>
          <Card.Text>
            Datum: {datum} <br />
            Ime fizičkog lica: {naziv} <br />
            Kontakt telefon: {kontakt} <br />
            Ostvareni profit: {cijena} KM <br />
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
}

export default HistorijaSaradnje;
